import React, { Suspense, useRef } from 'react';

import { getServerStream } from '@confluence/ssr-data-streaming';

import { getDataFetcherForSuspense, type SuspenseableDataFetcher } from './dataFetcherForSuspense';

function SuspenseWithDataFetcherReader({
	dataFetcher,
	children,
}: {
	dataFetcher: SuspenseableDataFetcher | null;
	children: React.ReactNode;
}) {
	dataFetcher?.read();
	return <>{children}</>;
}

export function SuspenseWithDataFetcher({
	dataFetcherName,
	fallback = null,
	children,
}: {
	dataFetcherName: string;
	fallback?: React.ReactNode;
	children: React.ReactNode;
}) {
	const initializedRef = useRef(false);
	const dataFetcher = getDataFetcherForSuspense(dataFetcherName);

	if (window.__SSR_REACT_STREAMING__) {
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		if (process.env.REACT_SSR) {
			if (dataFetcher && !initializedRef.current) {
				const stream = getServerStream('data-fetcher-done');
				void dataFetcher.get().finally(() => {
					stream.emit({ name: dataFetcherName });
				});
				initializedRef.current = true;
			}
		}

		return (
			<Suspense fallback={fallback}>
				<SuspenseWithDataFetcherReader dataFetcher={dataFetcher}>
					{children}
				</SuspenseWithDataFetcherReader>
			</Suspense>
		);
	} else {
		return <>{children}</>;
	}
}
